import {initializeApp} from 'firebase/app';
import {getMessaging, getToken, onMessage} from 'firebase/messaging';

const VITE_API_BASE_URL = import.meta.env.VITE_API_BASE_URL + '/api/fcm'

const firebaseConfig = {
    apiKey: "AIzaSyDiwcbi3uacZBxJCh1RFaZAVscwq78WFCs",
    authDomain: "ninaks-push.firebaseapp.com",
    projectId: "ninaks-push",
    storageBucket: "ninaks-push.firebasestorage.app",
    messagingSenderId: "953504270100",
    appId: "1:953504270100:web:8d53a1b64de1015397a401",
    measurementId: "G-LP9JVM0BLY"
};

const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);

export const requestFirebaseNotificationPermission = async () => {
    try {
        const currentToken = await getToken(messaging, {
            vapidKey: "BDXmjy-USHWkjrc1vLWrvKUe_BfFzDNWMsWkTaJMwFwHC5hiFwMqGt54Khi-uHLBJvvRg3Kh3obm0oMrjyYBuxo", // from Firebase Console → Cloud Messaging tab
            serviceWorkerRegistration: await navigator.serviceWorker.register('/firebase-messaging-sw.js'),
        });

        if (!currentToken) {
            console.warn('❌ No FCM token received');
            return;
        }

        const savedToken = localStorage.getItem('fcmToken');

        if (currentToken !== savedToken) {
            await fetch(`${VITE_API_BASE_URL}/save-fcm-token`, {
                method: 'POST',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify({token: currentToken}),
            });
            localStorage.setItem('fcmToken', currentToken);
        } else {
            console.log('ℹ️ Token already registered');
        }
    } catch (err) {
        console.error('❌ Error getting FCM token:', err);
    }
};

export const onMessageListener = (callback: any) => {
    onMessage(messaging, (payload) => {
        callback(payload);
    });
};